import { Map } from 'immutable';

import { TypedMap } from 'utils/typed-map';
import { LocalSettingsSetAction } from 'localSettings/actions';

import { SET } from './constants';

export interface LocalSettingsMutable {
  viewerCountry?: string | null;
  timeZone?: string | null;
}

export type LocalSettingsState = TypedMap<LocalSettingsMutable>;

const initialState = Map() as LocalSettingsState;

export default (
  state = initialState,
  action:
    | LocalSettingsSetAction
    | { type: 'persist/REHYDRATE'; payload: { localSettings: LocalSettingsState } }
    | { type: 'RESET_LOCAL_SETTINGS' }
): LocalSettingsState => {
  switch (action.type) {
    case SET:
      return state.set(action.key, action.value);

    case 'persist/REHYDRATE':
      return action?.payload?.localSettings || state;

    case 'RESET_LOCAL_SETTINGS':
      return initialState;

    default:
      return state;
  }
};
